import '@vfde-brix/headline/dist/styles.css';
import { createHeadline } from '@vfde-brix/headline';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-headline', createHeadline, NO_PATTERN_BUSINESS_LOGIC);
